export default __webpack_public_path__ + "static/media/LUCA_portfolio_page.47c48a94.png";